import { NgModule } from '@angular/core';
import { featureFlags } from '@utils/feature-flags';
import { UIRouterModule } from '@uirouter/angular';
import type { ModuleStatesDeclaration } from 'types/StateDeclaration';
import { LegalTermsComponent } from './containers/legal-terms.component';
import { LegalTermsNewComponent } from './containers/legal-terms-new.component';

// TODO: Remove FT and set/rename LegalTermsNewComponent as default and delete the module file (after release)
const jobShareListFT = featureFlags.isOn('Frontend.jobShareListRedesign');

const routes: ModuleStatesDeclaration = {
  states: [
    {
      name: 'legal-terms',
      url: '/legal-terms/:document',
      params: {
        document: 'privacy-policy'
      },
      component: jobShareListFT ? LegalTermsNewComponent : LegalTermsComponent,
      data: {
        ignoreStateAsTitle: true,
        mobileHeaderTitle: 'page-titles.legal-terms.title',
        bodyClass: (APP: string) => {
          'ngInject';

          if (APP !== 'public') {
            return 'app-white';
          }
        }
      }
    }
  ]
};

@NgModule({
  imports: [UIRouterModule.forChild(routes)]
})
export class LegalTermsRoutingModule {}
